exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".font-configurator__row {\n  align-items: center;\n  padding-top: 1rem;\n  padding-bottom: 1rem; }\n  .font-configurator__row:not(:last-child) {\n    border-bottom: 1px solid #ccc; }\n\n.font-configurator__add-font {\n  flex: 1;\n  margin-bottom: 0; }\n\n.font-configurator__button {\n  cursor: pointer; }\n\n.font-configurator__trigger {\n  margin-bottom: 0; }\n  .font-configurator__trigger div {\n    overflow: hidden;\n    white-space: nowrap; }\n\n.font-configurator__fonts {\n  max-height: 300px;\n  overflow-y: scroll;\n  overflow-x: hidden; }\n\n.font-configurator__fonts__font, .font-configurator__fonts-list__font {\n  font-size: 1rem;\n  align-self: center;\n  flex: 1; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader?sourceMap!./src/components/widgets/FontConfigurator/FontConfigurator.scss
// module id = 1389
// module chunks = 0